export const PANEL_ICONS = [
  'ad', 'banners', 'bell', 'box', 'building-store', 'category', 'certificate', 'credit-card',
  'discount', 'file-description', 'help-circle', 'info-circle', 'layers-linked', 'lifebuoy',
  'list-check', 'map', 'news', 'packages', 'push-notification', 'receipt-2',
  'rosette-discount-check', 'settings', 'settings-2', 'shield-lock', 'shopping-cart', 'stars',
  'ticket', 'truck', 'user', 'user-shield', 'users', 'wallet', 'layout-dashboard', 'clock-question', 'flame', 'thumb-up',
  'report', 'chart-bar', 'external-link', 'download'
]
